import { apiGET } from "../apis/handler";
import API from "../apis/axios";

export const getVoicebotCallTypesMeta = () => apiGET("/integration/api/voicebot/calls/meta/");

export const getVoicebotCalls = (params) => apiGET("/integration/api/voicebot/calls/", params);

export const getVoicebotCallDetail = (callType, id) =>
  apiGET(`/integration/api/voicebot/calls/${callType}/${id}/`);

// Recording audio isn't JSON — fetch as a blob so it can be played via an object URL.
export const getVoicebotCallRecording = async (callType, id) => {
  try {
    const res = await API.get(`/integration/api/voicebot/calls/${callType}/${id}/recording/`, {
      responseType: "blob",
    });
    return { success: true, data: res.data };
  } catch (error) {
    return { success: false, data: error?.response?.data, code: error?.response?.status };
  }
};
